<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ statInspIcon }}</md-icon>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <label class="md-layout-item md-form-label">Search:</label>
              <div class="md-layout-item md-size-50">
                <md-field>
                  <md-input
                    type="search"
                    clearable
                    placeholder="e.g. site name, building name/address or serial no"
                    v-model="searchCriteria.searchText"
                    @keydown.enter.native="searchPlantsWithoutStatInsp()"
                  ></md-input>
                  <md-button
                    class="md-icon-button md-primary"
                    @click="searchPlantsWithoutStatInsp()"
                  >
                    <md-icon>search</md-icon>
                  </md-button>
                </md-field>
              </div>
            </div>
            <md-table
              v-model="plantWithoutStatInsp.items"
              class="table-striped"
              table-header-color="primary"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Serial No">
                  {{ item.serialNo }}
                </md-table-cell>
                <md-table-cell md-label="Plant Type">
                  {{ item.plantType }}
                </md-table-cell>
                <md-table-cell md-label="Site Name">
                  {{ item.siteName }}
                </md-table-cell>
                <md-table-cell md-label="Address">
                  {{ item.address }}
                </md-table-cell>
                <md-table-cell class="text-right">
                  <add-button
                    :isSmall="true"
                    tooltip="Create Stat. Insp."
                    @add-click="createStatInsp(item.id)"
                  ></add-button>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state
                md-label="No Plant Found"
              ></md-table-empty-state>
            </md-table>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} outstanding
                items
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-default"
              v-model="searchCriteria.currentPage"
              :per-page="searchCriteria.itemsPerPage"
              :total="this.total"
            ></pagination>
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>find_in_page</md-icon>
            </div>
            <h4 class="title">Additional Filters</h4>
          </md-card-header>
          <md-card-content>
            <md-field>
              <label for="client">Client</label
              ><md-select
                v-model="filterCriteria.clientId"
                name="client"
                id="client"
                @md-selected="changeStatus()"
              >
                <md-option value="0">All</md-option>
                <md-option
                  v-for="client in permittedClients"
                  :key="client.id"
                  :value="client.id"
                >
                  {{ client.name }}
                </md-option>
              </md-select>
            </md-field>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import { mapGetters } from "vuex";

export default {
  name: "plants-without-stat-insps",
  components: {
    Pagination
  },
  computed: {
    ...mapGetters({
      statInspIcon: "stat-insp/icon",
      plantWithoutStatInsp: "stat-insp/plantsWithoutStatInsp"
    }),
    to() {
      let highBound = this.from + this.searchCriteria.itemsPerPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return (
        this.searchCriteria.itemsPerPage * (this.searchCriteria.currentPage - 1)
      );
    },
    total() {
      return this.plantWithoutStatInsp.total;
    },
    permittedClients() {
      return this.$auth.profile.clients;
    }
  },
  async created() {
    this.$route.query.clientId !== undefined
      ? (this.filterCriteria.clientId = this.$route.query.clientId)
      : "0";

    await this.getPlantItems();
  },
  data() {
    return {
      filterCriteria: {
        clientId: "0"
      },
      searchCriteria: {
        searchText: undefined,
        currentPage: 1,
        itemsPerPage: 15
      }
    };
  },
  methods: {
    createStatInsp(id) {
      this.$router.push({
        name: "Create Statutory Inspection",
        params: { plantId: id }
      });
    },
    async searchPlantsWithoutStatInsp() {
      await this.getPlantItems();
    },
    async getPlantItems() {
      await this.$store.dispatch("stat-insp/getPlantsWithoutStatInspListing", {
        filterCriteria: this.filterCriteria,
        searchCriteria: this.searchCriteria
      });
    },
    async changeStatus() {
      await this.getPlantItems();
    }
  },
  watch: {
    async from() {
      await this.getPlantItems();
    }
  }
};
</script>

<style></style>
